import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { useContent } from "../contexts/ContentContext";

export default function Navbar({ onEnquire }) {
  const { content } = useContent();
  const { company, navLinks } = content;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur shadow-sm"
          : "bg-white/90 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8 h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2 group">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#0e6e63] to-[#0a4f47] flex items-center justify-center shadow-md">
            <svg viewBox="0 0 24 24" className="w-6 h-6 text-orange-400" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4" fill="currentColor"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>
          </div>
          <div className="leading-none">
            <div className="text-[#0a4f47] font-extrabold text-lg tracking-wide">{company.logoText}</div>
            <div className="text-orange-500 text-[10px] font-bold tracking-[0.25em]">{company.logoSubText}</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-slate-700 hover:text-[#0a4f47] text-[15px] font-medium relative after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-orange-500 hover:after:w-full after:transition-[width] after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href={`tel:${company.phone}`} className="hidden md:flex items-center gap-2 text-sm text-slate-700 hover:text-[#0a4f47]">
            <Phone className="w-4 h-4" /> {company.phone}
          </a>
          <Button
            onClick={onEnquire}
            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 h-10 rounded-md shadow-md hover:shadow-lg transition-shadow"
          >
            Enquire Now
          </Button>
          <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t bg-white">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <a key={l.label} href={l.href} className="text-slate-700 py-1.5" onClick={() => setOpen(false)}>
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
